module.exports = __webpack_public_path__ + "img/figure-1.3f3a83b4.png";